// Owner disabled Redo's unsolicited save-for-later panel, not customer accounts or chat.
(() => {
  if (window.__ihSaveLaterDismissal) return;
  window.__ihSaveLaterDismissal = { dismissed: 0 };
  const watched = new WeakSet();
  const dismissed = new WeakSet();
  const queued = new WeakSet();
  function scan(root) {
    for (const title of root.querySelectorAll('[data-arbiter="Text"]')) {
      if (title.textContent.trim() !== 'Save these for later?') continue;
      let panel = title.parentElement;
      for (let depth = 0; panel && depth < 5; depth++, panel = panel.parentElement) {
        if (getComputedStyle(panel).position !== 'fixed') continue;
        if (!panel.textContent.includes('Automatically save these items for later inside your account.')) break;
        const close = panel.querySelector('button[data-web="IconButton"]');
        if (!close || dismissed.has(panel)) break;
        dismissed.add(panel);
        panel.style.setProperty('display', 'none', 'important');
        // Redo's own close action sets hasResolvedSlideInPanel and preserves saved products.
        window.setTimeout(() => {
          if (close.isConnected) close.click();
          window.__ihSaveLaterDismissal.dismissed++;
        }, 0);
        break;
      }
    }
  }
  function watch(root) {
    if (watched.has(root)) return;
    watched.add(root);
    new MutationObserver(() => {
      if (queued.has(root)) return;
      queued.add(root);
      requestAnimationFrame(() => { queued.delete(root); scan(root); });
    }).observe(root, { childList: true, subtree: true });
    scan(root);
  }
  function discover() {
    const root = document.getElementById('redo-storefront-container')?.shadowRoot;
    if (root) watch(root);
  }
  new MutationObserver(discover).observe(document, { childList: true, subtree: true });
  discover();
  // Attaching a shadow root does not emit a document child-list mutation.
  window.setInterval(discover, 1000);
})();
